// @flow

export { default as Icon } from './Icon';
export { default as IconStacked } from './IconStacked';
export { default as T4BIcon } from './T4BIcon';
